import { useContext, useState } from "react";
import Campo from "../Campo";
import styles from "./styles.module.css";
import VerificaForm from "../../controllers/VerificaForm";
import { UserContext } from "../../context/UserContext";
import putEdital from "../../services/putEdital";
import { Edital } from "../../model/Edital";

type Props = {
  editalObj: Edital;
  setEdital: React.Dispatch<React.SetStateAction<Edital>>;
  closeModal: Function;
};

const EditColaboracao = ({ editalObj, setEdital, closeModal } : Props) => {
  const [id, setId] = useState(editalObj.id);
  const [titulo, setTitulo] = useState(editalObj.titulo || "");
  const [descricao, setDescricao] = useState(editalObj.descricao || "");
  const [link, setLink] = useState(editalObj.link || "");
  const [dataInicio, setDataInicio] = useState(editalObj.inicio || "");
  const [dataFim, setDataFim] = useState(editalObj.fim || "");
  const { token } = useContext(UserContext);

  const salvarDados = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const editarEdital = async () => {
      try {
        await putEdital(token, id, titulo, descricao, link, dataInicio, dataFim);
        setEdital({
          id: id || editalObj.id,
          titulo: titulo || editalObj.titulo,
          descricao: descricao || editalObj.descricao,
          link: link || editalObj.link,
          inicio: dataInicio || editalObj.inicio,
          fim: dataFim || editalObj.fim
        })
      } catch (err) {
        console.log("Erro ao editar Colaboração", err);
      }
    };
    if (VerificaForm(e.currentTarget.form)) {
      editarEdital();
      closeModal();
    }
  }; 


  return (
    <form className={styles.formModal} onSubmit={salvarDados}>
      <h2>Alterar o Edital de Colaboração</h2>
      <Campo
        title="Titulo"
        placeholder="Escreva o Titulo da Colaboração"
        type="text"
        customValidity="Preencha com o Titulo da Colaboração"
        value={titulo}
        setter={setTitulo}
        required
      />
      <Campo
        title="Descrição"
        placeholder="Escreva a Descrição da sua Colaboração"
        type="text"
        customValidity="Preencha com a Descrição da sua Colaboração"
        value={descricao}
        setter={setDescricao}
        required
      />
      <Campo
        title="Link PDF"
        placeholder="Coloque o link do Edital"
        type="text"
        customValidity="Preencha com o link do Edital"
        value={link}
        setter={setLink}
        required
      />
      <div className={styles.gridCampos}>
        <Campo
          title="Inicio do periodo"
          type="date"
          customValidity="Preencha com a data de Inicio do periodo de Colaboração"
          value={dataInicio}
          setter={setDataInicio}
          required
        />
        <Campo
          title="Fim do periodo"
          type="date"
          customValidity="Preencha com a data de Fim do periodo de Colaboração"
          value={dataFim}
          setter={setDataFim}
          required
        />
      </div>
      <hr className={styles.separador} />
      <input type="submit" value="Editar Edital" />
    </form>
  );
};

export default EditColaboracao;
